import axios from 'axios'

// 创建axios实例
const service = axios.create({
  baseURL: 'https://api.holyiac.com/socket-service', // api的base_url
  // baseURL: 'http://192.168.3.55:8000/socket-service', // api的base_url
  timeout: 15000 // 请求超时时间
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data
    if (res !== "success" && res.code !== 200) {
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error)// for debug
    return Promise.reject(error)
  }
)

export default service
